import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VDialog,{attrs:{"width":"600"},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},[_c(VCard,[_c(VToolbar,{attrs:{"color":"blue-grey darken-2","dark":""}},[_c(VCardTitle,{staticClass:"headline"},[_vm._v(_vm._s(_vm.Headline))])],1),_c(VCardText,{staticClass:"pt-5"},[_vm._v("\n      "+_vm._s(_vm.Content)+"\n    ")]),_c(VCardActions,[_c(VSpacer),_c('BaseButton',{attrs:{"buttonText":_vm.ButtonConfirm,"isDisabled":false},on:{"click":_vm.Confirm}}),_c(VSpacer)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }